import React, { useState } from "react";
import { Link } from "react-router-dom";
import TrackCommentsForm from "../../Components/Elements/Forms/TrackCommentsForm";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TrackComment from "../../Components/Elements/TrackComment";
import AdditionalFileUnder from "~/Components/Elements/AdditionalFileUnder";

const TrackCommentsDisplay = ({ track, layoutCols, playlists }) => {
  const [replies, setReplies] = useState(track.replies);
  const playlistsForTrack = (playlists && playlists[track.id]) || [];
  return (
    <div>
      <div className="totd-inline-comment">
        <AdditionalFileUnder trackId={track && track.id} />

        <TrackCommentsForm layoutCols={layoutCols} track={track} onReply={(r) => setReplies(r)} showWysiwyg={false} />

      </div>
      {playlistsForTrack.length > 0 && (
        <div className="playlistListAboveComments">
          <strong>Added to Playlists:</strong>
          {playlistsForTrack.map((p) => (
            <Link to={`/playlist/${p.id}`}>{p.name}</Link>
          ))}
        </div>
      )}

      {replies.length > 0 && (
        <div className="totd-comments">
          <h4>
            <FontAwesomeIcon icon="comment" className="comment" style={{ marginRight: "6px" }} /> Comments ({replies.length})
          </h4>
          <div className="totd-comments-home">
            {replies.map((comment) => (
              <div className="totd-comments-list" key={comment.id}>
                <TrackComment isHome={true} comment={comment} />
              </div>
            ))}
          </div>
          {replies.length > 2 && (
            <div className="text-right view-more">
              <Link to={`/${track.id}`}>View full messages &raquo;</Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TrackCommentsDisplay;
